import microuniversoApi from "app/api/microuniversoApi"
import store from "app/redux/store/store"
import globalMU from "globalMU"
import * as atualizacaoOrcamentoLegadoActions from 'app/redux/atualizacaoOrcamentoLegadoSlice'
import * as atualizacaoItensOrcamentoLegadoActions from 'app/redux/atualizacaoItensOrcamentoLegadoSlice'
import { atualizarItemAction } from "app/redux/orcamentoSlice"

declare var window:any


export type AlterarPercentualMarkupItemParams = {
    identificadorItem: number,
    percentualMarkup: number
}

export async function alterarPercentualMarkupItem(params: AlterarPercentualMarkupItemParams) {
    try {
        globalMU.blockUI()

        const orcamentoAtualizado = await microuniversoApi.Orcamento.definirMarkUpProdutoItemOrcamento(params.identificadorItem,
            store.getState().orcamento.IdentificadorOrcamento, params.percentualMarkup)

            const itemAtualizado = orcamentoAtualizado.ItensOrcamento.find(i => i.Identificador == params.identificadorItem)
    
            const orcamentoLegado = window.orcamentoController.model
            // const itensLegado = orcamentoLegado.get('ItensOrcamento')
            // const itemLegado = itensLegado.models.find(item => item.get('Identificador') == params.identificadorItem)
    
            // itemLegado?.atualizar(itemAtualizado,false)

            store.dispatch(atualizacaoItensOrcamentoLegadoActions.atualizarItem({
                identificador: itemAtualizado.Identificador,
                dadosItem: itemAtualizado
            }))
            
            orcamentoLegado.atualizar(orcamentoAtualizado, true , true)

            store.dispatch(atualizarItemAction({
                identificador: params.identificadorItem,
                dados: {UltimaInformacaoAtualizada: "PERCENTUAL_MARKUP"}
            }))

            store.dispatch(atualizacaoOrcamentoLegadoActions.atualizar(orcamentoAtualizado))
    } finally {
        globalMU.unblockUI()
    }
}